var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionInitiatedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.271,
    height: 19.849,
    viewBox: "0 0 16.271 19.849",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "play_arrow_FILL1_wght700_GRAD0_opsz48",
    d: "M17.267,29.033a1.578,1.578,0,0,1-1.689.052,1.534,1.534,0,0,1-.827-1.431V11.106a1.534,1.534,0,0,1,.827-1.431,1.578,1.578,0,0,1,1.689.052l12.962,8.308a1.513,1.513,0,0,1,.793,1.362,1.438,1.438,0,0,1-.793,1.327Z",
    transform: "translate(-14.75 -9.455)",
    fill: "#62b0dc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionInitiatedIcon);
export default __webpack_public_path__ + "static/media/ActionInitiatedIcon.f35c824f3aa05a8abc463044ec6eed29.svg";
export { ForwardRef as ReactComponent };